import * as logger from 'loglevel';

import { isDevelopment } from '../Environment';
import { toBoolean } from '../String';

const forceRemoteLog = toBoolean(process.env.REACT_APP_ALWAYS_LOG_REMOTE, false);

/**
 * An early implementation of remote logger based on loglevel
 */
// TODO: Remove log call from production build (https://github.com/facebook/create-react-app/pull/9222)
// TODO: Should we throttle logRemote call?

/**
 * A custom logger built on loglevel.
 *
 */
const logRemote = () => {
  if (isDevelopment() && !forceRemoteLog) return null;
  return null;
  /* return axios
    .post(`${baseURL}/system/logger/${type}`, {
      message,
      error: {
        name: err?.name,
        stack: err?.stack,
      },
      ...(other
        ? {
            json: {
              ...other,
            },
          }
        : {}),
      meta: {
        environment: process.env.NODE_ENV,
        href: window.location.href,
        version: process.env.REACT_APP_VERSION,
        app: process.env.REACT_APP_NAME,
      },
    })
    .catch(); */
};

const log = {
  ...logger,
  error: (...msg) => {
    logger.error(msg);

    const [message, err, ...other] = msg;
    logRemote('error', message, err, other);
  },
  warn: (...msg) => {
    logger.warn(msg);

    const [message, details] = msg;
    logRemote('warn', message, null, details);
  },
};

export default log;
